import React, { useEffect, useMemo } from 'react';
import {
  Alert, Button, Col, Container, Row, Spinner,
} from 'react-bootstrap';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { emitFunnelEvent } from '../../analytics/externalSalesAnalytics';
import { EXTERNAL_SALES_BASE_PATH } from '../../config';
import { readUtm } from '../../readUtm';
import { OfferCard } from './OfferCard';
import { useCampaign } from './useCampaign';

export function LandingPage() {
  const { campaignCode } = useParams<{ campaignCode: string }>();
  const history = useHistory();
  const { search } = useLocation();
  const utm = useMemo(() => readUtm(search), [search]);
  const { state, reload } = useCampaign(campaignCode);

  useEffect(() => {
    emitFunnelEvent({ event: 'Landing_View', data: { campaignCode, utm } });
  }, [campaignCode, utm]);

  const handleBuy = (sku: string) => {
    emitFunnelEvent({ event: 'Buy_Click', data: { campaignCode, sku, utm } });
    history.push(
      `${EXTERNAL_SALES_BASE_PATH}/c/${encodeURIComponent(campaignCode)}/checkout?sku=${encodeURIComponent(sku)}`,
    );
  };

  return (
    <div className="external-sales-page">
      <Container as="main" className="external-sales-landing py-5">
        {state.kind === 'loading' && (
          <div className="text-center py-5" role="status">
            <Spinner animation="border" variant="primary" aria-hidden="true" />
            <p className="mt-3 mb-0 text-muted">Loading offers…</p>
          </div>
        )}

        {state.kind === 'error' && (
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Alert variant="danger" className="text-center">
                <p className="mb-3">We couldn’t load this campaign. Please try again.</p>
                <Button variant="outline-danger" onClick={reload}>Retry</Button>
              </Alert>
            </Col>
          </Row>
        )}

        {state.kind === 'empty' && (
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Alert variant="info" className="text-center mb-0">This campaign has no offers available.</Alert>
            </Col>
          </Row>
        )}

        {state.kind === 'loaded' && (
          <Row className="justify-content-center">
            {state.campaign.offers.map((offer) => (
              <Col key={offer.sku} xs={12} sm={6} lg={4} className="mb-4 d-flex">
                <OfferCard offer={offer} onBuy={handleBuy} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
}
